export enum CreationSegmentsType {
  AUTO = 'auto',
  MANUAL = 'manual'
}